import * as React from 'react'
import * as ReactRedux from 'react-redux'
import { Helmet } from 'react-helmet-async'

import * as Herz from '@rushplay/herz'

import * as Configuration from './configuration'
import { useBrand } from './use-brand'

export function SeoJsonLd() {
  const translate = Herz.I18n.useTranslate()

  const origin = ReactRedux.useSelector(state =>
    Configuration.getOrigin(state.configuration)
  )

  const brand = useBrand()

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://www.schema.org',
          '@type': 'Organization',
          name: `${brand}.com`,
          legalName: `${brand}.com`,
          alternateName: brand,
          description: translate('seo.start.desc'),
          logo: `${origin}/images/${
            brand === 'starsplay24' ? 'logo-24' : 'logo'
          }.svg`,
          url: origin,
          foundingDate: '2025',
        })}
      </script>
    </Helmet>
  )
}

Herz.I18n.Loader.preload(['seo.start.desc'], SeoJsonLd)
